export const secinmillis = time => {
  const date = new Date(time);
  const hour = (date.getHours() < 10 ? '0' : '') + date.getHours();
  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  return `${hour}:${minutes}`;
};
